import type { FaireProductEntity } from "../../entity_types/product";

export const p_azm4b8ydhd: FaireProductEntity = {
  token: "p_azm4b8ydhd",
  type: "product",
  name: "Wooden Puzzle - Stacking Rings - Fruit of the Spirit",
  brandToken: "b_29xxo8ggi7",
  brandName: "Swanson Christian Products",
  imageUrl:
    "https://cdn.faire.com/fastly/7ce47dfa60b216b7be01e107b9bcd8cd73cd4a0bee858cf63f761e6a3c5b0f55.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/98cba55c949e0d841a97de8e7ade1fce76037aa929db5bcfc839f7735049d73d.jpeg",
    "https://cdn.faire.com/fastly/9426d5fd79908313afbaa3808c837c4a028111d9e839b6df74a95740089c6320.jpeg",
    "https://cdn.faire.com/fastly/b0c36cb0aefa7876a4741155d8303a3aecf38e9a50836578d35eed7ae7c3d40d.jpeg",
    "https://cdn.faire.com/fastly/b3e43fd8ea74aa35d821bcd3e4805881c8205c1800a09350e0a9cc932b16c943.jpeg",
    "https://cdn.faire.com/fastly/ed4e052084e766c1519bf30d76570e175ffc26c1d9a8e38b703636252bc885fb.jpeg",
    "https://cdn.faire.com/fastly/1057180d2885cd0a59ff7eae7786339fc4ba4a2360b1f1a88ec322d1a8cd91ed.jpeg",
    "https://cdn.faire.com/fastly/1a045b80dbee7bee1108dbed801c1c0f79b7be7c0e1e9a80374c68af68743ff9.jpeg",
  ],
  priceDollars: 14.48,
  description:
    'Introduce your little ones to the joy of play with our Wooden Stacking Puzzle, designed for children aged 10 months and up. This colorful puzzle is inspired by the Fruits of the Spirit, blending fun with faith to help children connect with spiritual values as they play.\r\n\r\nMeasuring 4.625"L x 4.625"W x 7.5"H, the vibrant pieces are perfect for little hands to grasp. As children stack and balance the rings, they not only refine motor skills but also enhance coordination and spatial awareness. Each piece encourages focus and problem-solving, making it an ideal educational toy for young minds.\r\n\r\nThe faith-based design adds an extra layer of meaning to playtime, introducing concepts like love, joy, and kindness as they explore the colorful rings. Crafted from high-quality, non-toxic materials, this wooden puzzle is safe for children, providing parents with peace of mind.\r\n\r\nPerfect for gifting, this Wooden Stacking Puzzle offers long-lasting value, inspiring creativity, faith-based lea...',
  tags: [],
  msrpDollars: 26.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:05.512Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
